
CheckoutV2.Payment.GiftCard = function(checkout, payment, isReview) {
	var giftcard = this;

	this.label = 'Gift Cards';
	this.balance = 0;
	var section = '.js-payment';
	if (isReview)
		section = '.js-review';
	this.sessionKey = 'useGiftCards';

	this.$loadingOverlay = $('#add-gift-card-overlay');
	this.$error = $('#gift-card-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$errorClose = this.$error.find('.close');
	if (isReview) {
		this.$wrap = $();
		this.$content = $();
		this.$balance = $();
	} else {
		this.$wrap = $('.js-gift-cards');
		this.$content = $('.js-gift-cards');
		this.$balance = $('.js-gift-cards-total');
	}
	//this.$remainingBalance = giftcard.$content.find('.payment-method-amt-remaining');
	this.$checkbox = $(section + ' .js-payment-use-gift-card');
	//this.$useBalanceWrap = $('#payment-method-giftcard-use-wrap');
	//this.$displayBalance = giftcard.$useBalanceWrap.find('.payment-method-amt');
	this.$cardInput = $('#gift-card-number');
	this.$label = $(section + ' .js-payment-gift-card-wrap label');
	this.$add = $(section + ' .js-apply-gift-card');
	this.$addModal = $('#applyGiftCardModal');
	this.$applyButton = $('.js-apply-gift-card-btn');

	this.request = false;

	this.init = function() {
		if (!isReview) {
			checkout.session.set({
				'useGiftCards': 0
			});
		}
		giftcard.listen();
	};

	this.listen = function() {
		giftcard.$add.off('click');
		giftcard.$add.on('click', function() {
			giftcard.$addModal.modal('show');
		});
		
		giftcard.$addModal.off('hidden.bs.modal');
		giftcard.$addModal.on('hidden.bs.modal', function (e) {
			giftcard.error(false);
			giftcard.$cardInput.val('');
		});
		
		giftcard.$applyButton.off('click');
		giftcard.$applyButton.on('click', function(){
			giftcard.getCard();
		});

		giftcard.$checkbox.off('change');
		giftcard.$checkbox.change(function() {
			giftcard.changeUseBalance(true);
		});
		
		giftcard.$errorClose.off('click');
		giftcard.$errorClose.on('click', function(){
			giftcard.error(false);
		});
	};

	this.buildContent = function() {
		var giftcardBalance = (parseFloat(checkout.session.get('credits.giftCardBalance')) || 0),
			useGiftCards = checkout.session.get('useGiftCards') || 0;

		if (!giftcard.balance || giftcard.balance <= 0)
			giftcard.balance = giftcardBalance;

		//giftcard.balanceChanged();

		if (giftcard.balance <= 0) {
			useGiftCards = 0;
			$(section + ' .js-payment-gift-card-wrap').hide();
		} else {
			$(section + ' .js-payment-gift-card-wrap').show();
			giftcard.$label.html('Use your $' + giftcard.balance.toMoney() + ' ' + giftcard.label + ' balance <span class="js-remaining text-success"></span>');
			$(section + ' .js-apply-gift-card').text('+ Apply another ' + checkout.config.siteNameFirstWord + ' Gift Card');
			giftcard.$checkbox.prop('checked', useGiftCards && payment.cart_totals.values.balances[giftcard.label] > 0 );
		}

		//giftcard.$checkbox.prop('checked', ((useGiftCards) ? true : false));
		//giftcard.changeUseBalance(false);

	};

	this.balanceChanged = function() {
		if (giftcard.balance > 0) {
			$(section + ' .js-payment-gift-card-wrap').show();
			giftcard.$label.html('Use your $' + giftcard.balance.toMoney() + ' ' + giftcard.label + ' balance  <span class="js-remaining text-success"></span>');
			$(section + ' .js-apply-gift-card').text('+ Apply another ' + checkout.config.siteNameFirstWord + ' Gift Card');
		} else {
			$(section + ' .js-payment-gift-card-wrap').hide();
			$(section + ' .js-apply-gift-card').text('+ Apply an ' + checkout.config.siteNameFirstWord + ' Gift Card');
		}
		// need to update giftCardBalance in the session
		checkout.session.set('credits.giftCardBalance', giftcard.balance);
		// this needs to happen if we're in review, going from review back to payment, but review builds it each time
		if (isReview) $.each(checkout.payment.balanceMethods, function(idx, elem) {
			if (elem.sessionKey == giftcard.sessionKey) {
				elem.balance = giftcard.balance;
				elem.balanceChanged();
				return false;
			}
			return true;
		});
	};

	this.getCard = function() {
		var cardID = giftcard.$cardInput.val().trim().toUpperCase();

		if (giftcard.request)
			giftcard.request.abort();

		if (!cardID)
			return;

		giftcard.error(false);
		giftcard.$cardInput.blur();
		giftcard.loading('Loading Gift Card');

		giftcard.request = checkout.remote.call({
			'data': {
				'step': 'payment',
				'action': 'addGiftCard',
				'cardID': cardID
			}
		})
		.done(function(response) {
			giftcard.balance = response.data.balance;
			giftcard.balanceChanged();
			giftcard.$checkbox.prop('checked', true);
			giftcard.changeUseBalance(true);
			giftcard.$addModal.modal('hide');
		})
		.fail(function(request) {
			if (request.responseText) {
				giftcard.error(request.responseText);
			} else {
				giftcard.error('Gift card does not exist or has no remaining balance.');
			}
			giftcard.$cardInput.focus();
		})
		.always(function() {
			giftcard.loading(false);
		});
	};

	this.changeUseBalance = function(userEvent) {
		var useGiftCards = (giftcard.$checkbox.prop('checked') ? 1 : 0);

		if (useGiftCards) {
			giftcard.applyBalance(userEvent);
		} else {
			giftcard.removeBalance(userEvent);
		}

		if (checkout.session.get('useGiftCards') != useGiftCards) {
			checkout.session.set({
				'useGiftCards': useGiftCards
			});
			payment.saved = false;
		}
	};

	this.removeBalance = function(userEvent) {
		if (!payment.methodRequired) {
			giftcard.lock();
		}
		
		giftcard.$label.find('.js-remaining').text('');

		payment.changeBalanceMethod(giftcard, 0, userEvent);
	};

	this.lock = function() {
		giftcard.$cardInput.attr('disabled', 'disabled');
		giftcard.$add.attr('disabled', 'disabled');
		giftcard.$add.off('click');

		if (!giftcard.$checkbox.prop('checked')) {
			giftcard.$checkbox.attr('disabled', 'disabled');
		}
	};

	this.unlock = function() {
		giftcard.$cardInput.removeAttr('disabled');
		giftcard.$add.removeAttr('disabled');
		giftcard.$checkbox.removeAttr('disabled');
		giftcard.$add.on('click', function() {
			giftcard.$addModal.modal('show');
		});

	};

	this.reApplyBalance = function() {
		if (giftcard.$checkbox.prop('checked')) {
			giftcard.applyBalance(false);
		}
	};

	this.applyBalance = function(userEvent) {
		var usedBalanceTotal = 0;

		for (var i=0; i < payment.balanceMethods.length; i++) {
			var method = payment.balanceMethods[i];

			if (method.label == giftcard.label) {
				break;
			} else {
				usedBalanceTotal += (payment.cart_totals.values.balances[method.label] || 0);
			}
		}

		var applyBalance = (
			(parseFloat(payment.cart_totals.values.total) || 0)
			- usedBalanceTotal
		);

		if (applyBalance > giftcard.balance) {
			applyBalance = giftcard.balance;
		}

		applyBalance = (parseFloat(applyBalance.toMoney()) || 0);

		if (applyBalance <= 0) {
			giftcard.$checkbox.prop('checked', false);
			giftcard.changeUseBalance(false);
			return;
		}

		var remainingBalance = (giftcard.balance - applyBalance);

		if (remainingBalance < 0) {
			remainingBalance = 0;
		}
		
		if (remainingBalance) {
			giftcard.$label.find('.js-remaining').text('($' + remainingBalance.toMoney() + ' remaining)');
		} else {
			giftcard.$label.find('.js-remaining').text('');
		}

		payment.changeBalanceMethod(giftcard, applyBalance, userEvent);

	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			giftcard.$loadingOverlay.show();
		} else {
			giftcard.$loadingOverlay.hide();
		}
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			giftcard.$errorMsg.html(errorMsg);
			giftcard.$error.show();
		} else {
			giftcard.$error.hide();
			giftcard.$errorMsg.html('');
		}
	};

	this.init();
};
